import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const InvestorClassificationModelSchema = z
  .object({
    id: z.number(),
    label: z.string(),
    display_order: z.number().nullish()
  })
  .strict()

const InvestorClassificationModelFields = makeFieldKeys(InvestorClassificationModelSchema)

export type InvestorClassificationModel = z.infer<typeof InvestorClassificationModelSchema>

function validateInvestorClassificationModel(data: unknown): InvestorClassificationModel {
  try {
    return validateWithZodSchema(InvestorClassificationModelSchema, data, 'investor classification model')
  } catch (error) {
    throw new Error(`Investor classification model validation failed: ${error}`)
  }
}
